import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnrichEditorModule } from './editor/enrich-editor.module';
import { EmptyComponent } from './pages/empty.component';
import { EnrichRoutingModule } from './pages/routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ResourceModule } from './resources/resource.module';
import { GlobalServicesModule } from './services/global-services.module';
import { ErrorsModule } from './pages/errors/error.module';
import { SharedModule } from './shared/shared.module';

@NgModule({
  declarations: [
    AppComponent,
    EmptyComponent,
  ],
  entryComponents: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ResourceModule,
    GlobalServicesModule,
    CoreModule,
    SharedModule,
    EnrichEditorModule,
    EnrichRoutingModule,
    ErrorsModule,
  ],
  bootstrap: [
    AppComponent,
  ],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts